function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import z from 'zod';
var slugValidator = z.object({
    current: z.string().regex(/^[a-z0-9_/-]+$/, {
        message: 'Only letters, numbers, underscores, dashes and slashes are allowed'
    }).regex(/^(?!\/)/, {
        message: 'Can not start with a /'
    })
});
var factory = function factory() {
    return {
        type: 'slug',
        validation: function validation(Rule) {
            return Rule.required().custom(function(value) {
                var result = slugValidator.safeParse(value);
                if (result.success) return true;
                return result.error.issues[0].message;
            });
        },
        options: {
            slugify: function slugify(value) {
                return value.toLowerCase().trim().replace(/[^a-z0-9_-]/g, '-').replace(/--+/g, '-');
            },
            isUnique: function isUnique(slug, context) {
                return _async_to_generator(function() {
                    var document, getClient, client, id, params, query, result;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                document = context.document, getClient = context.getClient;
                                if (!(document === null || document === void 0 ? void 0 : document.language)) {
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                client = getClient({
                                    apiVersion: '2023-04-24'
                                });
                                id = document._id.replace(/^drafts\./, '');
                                params = {
                                    draft: "drafts.".concat(id),
                                    published: id,
                                    language: document.language,
                                    slug: slug
                                };
                                query = "!defined(*[\n        !(_id in [$draft, $published]) &&\n        slug.current == $slug &&\n        language == $language\n      ][0]._id)";
                                return [
                                    4,
                                    client.fetch(query, params)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        }
    };
};
export default {
    factory: factory,
    validator: slugValidator
};

//# sourceMappingURL=documentSlug.js.map